import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('COSTING_ESTIMATE', ['FORM', 'TABLE_PRODUCTS'])
